// Preview-only mirror of the API's renderer (apps/api/utils/alertLabelTemplate.ts). It uses a
// fixed sample reason instead of the reason-code table, which lives server-side.
export const SAMPLE_REASON_CODE = "13.1";
export const SAMPLE_REASON_DESCRIPTION = "Merchandise/Services Not Received";
export const SAMPLE_ALERT_TYPE = "Fraud";

export function previewOrderTags(template: string): string[] {
  return substitute(template)
    .split(",")
    .map((segment) => segment.trim())
    .filter((segment) => /[\p{L}\p{N}]/u.test(segment));
}

export function previewRefundReason(template: string): string {
  return substitute(template).trim();
}

function substitute(template: string): string {
  return template
    .split("${reasonCode}")
    .join(SAMPLE_REASON_CODE)
    .split("${reasonDescription}")
    .join(SAMPLE_REASON_DESCRIPTION)
    .split("${alertType}")
    .join(SAMPLE_ALERT_TYPE)
    .replace(/\s+/g, " ");
}
